import React from 'react';

import PageLayout from '../../components/layout/PageLayout';
import AdminDashboard from '../../components/admin/Dashboard';

const AdminDashboardPage = () => {
  return (
    <PageLayout>
      <AdminDashboard />
    </PageLayout>
  );
};

export default AdminDashboardPage;
